import React from 'react'

import { ReasonsWhySectionProps } from './types'
import Section from '../Section'
import ReasonsWhy from '../../organisms/ReasonsWhy'

const ReasonsWhySection: React.FC<ReasonsWhySectionProps> = ({ id, inner, paddingTop, paddingBottom, bgColor, heading, data }) => (
  <Section {...{ id, inner, paddingTop, paddingBottom, bgColor, heading }} body={<ReasonsWhy {...{ data }} />} />
)

export default ReasonsWhySection
